import * as api from '../api';

export const getDataFromServer = () => api.get(`/cms/homepage-projects`, {}, api.SERVER_V2);
